import { buildSelectedProductItemKey, SelectedProductItem } from "@/components/BatchAddProductModal/store";
import ProductSelectorTrigger from "@/components/ProductSelectorTrigger";
import ShopSettingDTO from "@/dto/shop/ShopSettingDTO";
import { getExcludedAutoMergeSkus, updateExcludedAutoMergeSkus } from "@/services/api/shop";
import { useRequest } from "ahooks";
import React, { useMemo } from "react";

interface AutoMergeExclusionRuleProps {
    shopSetting: ShopSettingDTO;
}

const AutoMergeExclusionRule: React.FC<AutoMergeExclusionRuleProps> = ({ shopSetting }) => {
    const { id: shopId } = shopSetting;

    const { loading: isLoadingExcludedSkus, refreshAsync: refreshExcludedSkus, data: excludedSkusData } = useRequest(
        async () => await getExcludedAutoMergeSkus(shopId),
    );

    const { runAsync: updateExcludedSkus, loading: isUpdating } = useRequest(
        async (excludedSkus: SelectedProductItem[]) => {
            await updateExcludedAutoMergeSkus({ shopId, excludedAutoMergeSkus: excludedSkus });
            await refreshExcludedSkus();
        },
        { manual: true },
    );

    const selectedProducts = useMemo<SelectedProductItem[]>(() => {
        if (!excludedSkusData?.length) return [];

        return excludedSkusData.map((sku) => ({
            key: buildSelectedProductItemKey(sku.shopId, sku.productOriginalId, sku.skuOriginalId),
            ...sku,
        }));
    }, [excludedSkusData]);

    return (
        <ProductSelectorTrigger
            checkboxContent="包含指定商品的订单不自动合并"
            defaultShopId={shopId}
            shopSelectDisabled
            loading={isLoadingExcludedSkus || isUpdating}
            onChange={updateExcludedSkus}
            value={selectedProducts}
        />
    );
};

export default React.memo(AutoMergeExclusionRule);
